import Config from '../config'
import Cookies from 'js-cookie'

const logUtility = !!(process.env.NODE_ENV !== 'production')

class Session {
  /**
   * Constructor a session instance
   *
   * @param attributes
   */
  constructor ({ expires }) {
    this._attributes = {}
    this._attributes[expires] = (expires === null || expires === undefined) ? (1 / 24) : expires
    this._cookies = Cookies
  }

  /**
   * Check if session has a specific key.
   *
   * @return boolean
   */
  has (name) {
    logUtility && console.log(`Checking if ${name} is present => ${this.get(name) !== undefined && this.get(name) !== null}`)
    return (this.get(name) !== undefined && this.get(name) !== null)
  }

  /**
   * Retrieve a cookie value
   *
   * @param name
   * @returns {*}
   */
  get (name) {
    logUtility && console.log(`Retrieving the value for => ${name} => ${this._cookies.get(name)}`)
    return this._cookies.get(name)
  }

  /**
   * Remove a cookie
   *
   * @param name
   */
  remove (name) {
    logUtility && console.log(`Removing the value ${name}`)
    this._cookies.remove(name, this._attributes)
  }

  /**
   * Set a cookie
   *
   * @param name
   * @param value
   */
  set (name, value) {
    logUtility && console.log(`Setting ${name} => ${value}`)
    this._cookies.set(name, value, this._attributes)
  }
}

export default new Session({ expires: Config.SESSION_EXPIRY_TIME })



// WEBPACK FOOTER //
// ./src/api/utilities/Session.js